export default __webpack_public_path__ + "8390ed7ce09ae196996942b3238198d9.png";